import { of } from "rxjs";
import { selectBalancingBuilding } from "../../../../balancingSelectors/selectBalancingBuildings";
import { IdBuilding } from "../../../../constants/IdBuilding";
import { actionBuildingsStartPlacement } from "../../../player-base/buildings/actionBuildings";
export var pathPurchaseBuilding = function (action, state$, deps) {
    var buildingBalancingInfo = selectBalancingBuilding(IdBuilding.Windmill);
    var buildingInfo = {
        balancing: buildingBalancingInfo,
        production: undefined,
        proto: {
            id: 6,
            posX: 39,
            posY: 42,
            remainingTime: undefined,
            stage: 1,
            state: 0,
            typeId: 8,
        },
    };
    return of(actionBuildingsStartPlacement(buildingInfo, false));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/restore/path/pathPurchaseBuilding.ts
// module id = 2475
// module chunks = 3